// Inert plugin for trapping focus

import 'wicg-inert'
